module.exports = __webpack_public_path__ + "static/media/PrivacyPolicy.227a6142.md";